import { z } from 'zod';
import { nonEmptyString, sqliteBool, utcNaiveTimestamp } from './common.ts';

export const announcementSeverityValues = ['info', 'warning', 'error', 'success'] as const;
export const announcementSeverity = z.enum(announcementSeverityValues);
export type AnnouncementSeverity = z.infer<typeof announcementSeverity>;

export const announcementTypeValues = ['general', 'maintenance', 'security', 'release'] as const;

export const announcement = z.object({
  id: z.number().int().positive(),
  title: nonEmptyString,
  message: nonEmptyString,
  severity: z.string(),
  type: z.string(),
  active: sqliteBool,
  created_at: utcNaiveTimestamp,
  updated_at: utcNaiveTimestamp,
});
export type Announcement = z.infer<typeof announcement>;

// POST /api/announcements
export const createAnnouncementInput = z.object({
  title: nonEmptyString,
  message: nonEmptyString,
  severity: z.string().optional(),
  type: z.string().optional(),
});
export type CreateAnnouncementInput = z.infer<typeof createAnnouncementInput>;

// PATCH /api/announcements/:id — either toggle `active`, or update content.
export const updateAnnouncementInput = z
  .object({
    active: z.boolean().optional(),
    title: z.string().optional(),
    message: z.string().optional(),
    severity: z.string().optional(),
    type: z.string().optional(),
  })
  .refine(
    (v) =>
      v.active !== undefined ||
      v.title !== undefined ||
      v.message !== undefined ||
      v.severity !== undefined ||
      v.type !== undefined,
    { message: 'at least one field must be provided' },
  );
export type UpdateAnnouncementInput = z.infer<typeof updateAnnouncementInput>;

export const announcementListResponse = z.array(announcement);
